module.exports = __webpack_public_path__ + "img/hamburger.601dc11b.svg";